import React, { useEffect, useState } from "react";
import GlobalCard from "../../../../../../components/GlobalCardComponent";
import { Box, Card, Grid, Tooltip, Typography } from "@mui/material";
import BlueLightOutlinedButton from "../../../../../../components/customButtons/BlueLightOutlineButton";
import NoAddressScreen from "./NoAddressScreen";
import BlueMediumButton from "../../../../../../components/customButtons/BlueMediumButton";
import CustomPopup from "../../../../../../components/customPopup/CustomPopup";
import AddNewAddressForm from "./AddNewAddressForm";
import SussceeffulyMessageScreen from "../../../../../../components/customPopup/SussceeffulyMessageScreen";
import ShowAllAddressList from "./ShowAllAddressList";
import { setDefaultAddressData } from "../../../../../../../redux/features/userAddress/addressDataSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUserAddress,
  getAdressOfUser,
} from "../../../../../testPrepDashboard/Api/DashboardApi";
import { Icon } from "@iconify/react/dist/iconify.js";
import Loader from "../../../../../../../SAPPages/components/Loader/Loader";
import EditNewAddress from "./editNewAddressForm";
import DeleteConfirmationPopup from "../../../../../../components/customPopup/DeleteConfirmationPopup";
import ErrorPopupScreen from "../../../../../../components/customPopup/ErrorPopupScreen";

export default function TestBillingAddress() {
  const userId = localStorage.getItem("userId");
  const [OpenAddAddressPopup, setOpenAddAddressPopup] = useState(false);
  const [openAddressListPopup, setOpenAddressListPopup] = useState(false);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [messageTitle, setMessageTitle] = useState(null);
  const [subMessage, setSubMessage] = useState(null);
  const [refreshPage, setRefreshPage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [OpenEditAddress, setOpenEditAddress] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [buttonTitle, setButtonTitle] = useState(null);
   const dispatch = useDispatch();

  const defaultAddressData = useSelector(
    (state) => state.testAddressData?.defaultAddressData
  );

    const [userAddress, setUserAddress] = useState([]);
  
useEffect(() => {
 setUserAddress(defaultAddressData)
}, [defaultAddressData])


  // open  add address popup
  const handleOpenAddAddressPopup = () => {
    setOpenAddAddressPopup(true);
  };

  // close add address popup

  const handleCloseAddAddressPopup = () => {
    setOpenAddAddressPopup(false);
  };

  // open  open address list popup
  const handleOpenAddressListPopup = () => {
    setOpenAddressListPopup(true);
  };

  // close  address list popup

  const handleCloseAddressListPopup = () => {
    setOpenAddressListPopup(false);
  };

  // open success popup
  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);

  // close success popup
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

 

  const handlefetchAddress = async () => {
    setLoading(true);
    try {
      const response = await getAdressOfUser({
        user_id: parseInt(userId),
      });

      const selectedAddress = response?.data?.find(
        (i) => i.is_default === true
      );

      if (selectedAddress) {
        dispatch(setDefaultAddressData(selectedAddress)); // Redux
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching address:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    handlefetchAddress(userId);
  }, [userId]);

  // open Edit Popup
  const handleOpenEditressPopup = (rowData) => {
    setOpenEditAddress(true);
    setSelectedData(rowData);
  };

  // close edit popup
  const handleCloseEditAddressPopup = () => {
    setOpenEditAddress(false);
  };

  // open delete popup
  const handleOpendeletePopup = (rowId) => {
    setOpenDeleteConfirmation(true);
    setSelectedRowId(rowId);
  };

  // close delete popup

  const handleClosedeletePopup = () => {
    setOpenDeleteConfirmation(false);
  };

  // Delete Address
  const handleCancelAddress = async () => {
    try {
      const response = await deleteUserAddress({
        user_id: parseInt(userId),
        id: selectedRowId,
      });

      if (response.statusCode === 200) {
        handleClosedeletePopup();
        // Update state: remove deleted address
        // setUserAddress((prevAddresses) =>
        //   prevAddresses.filter((addr) => addr?.id !== selectedRowId)
        // );
        handleOpenSuccessPopup();
        setMessageTitle("Address Deleted Successfully !!");
      } else if (response.statusCode === 400) {
        setMessageTitle(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Got It");
      } else if (response.statusCode === 404) {
        setMessageTitle(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Got It");
      } else if (response.statusCode === 500) {
        setMessageTitle(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Try Again");
      } else {
        setMessageTitle("Internal Server Error");
        handleOpenErrorPopup();
        setButtonTitle("Try Again");
      }
    } catch (error) {
      setMessageTitle("Internal Server Error");
      handleOpenErrorPopup();
      setButtonTitle("Try Again");
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  return (
    <>
      <GlobalCard >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography
              textAlign="start"
              color="#222222"
              fontFamily="Inter"
              fontSize="18px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 500 }}
            >
              Billing Address
            </Typography>
          </Grid>

          <Grid item xs={6} container gap={2} justifyContent="flex-end">
            {defaultAddressData && !loading ? (
              <BlueLightOutlinedButton
                buttonTitle="Change Address"
                onClick={handleOpenAddressListPopup}
              />
            ) : !defaultAddressData && !loading ? (
              <BlueMediumButton
                buttonTitle="Add New"
                onClick={handleOpenAddAddressPopup}
              />
            ) : (
              " "
            )}
          </Grid>
          {loading && (
            <Grid item xs={12}>
              <Loader text="Loading Address..." height="20vh" />
            </Grid>
          )}

          {!defaultAddressData && !loading && (
            <Grid item xs={12}>
              <NoAddressScreen />
            </Grid>
          )}

          {defaultAddressData && (
            <Grid item xs={12}>
              <Card
                sx={{
                  border: "2px solid #FFE2FA",

                  // boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",

                  cursor: "pointer",
                  padding: "10px",
                  width: "100%",
                  borderRadius: "8px",
                  // background: "#FBF4FF",

                  px: { xs: 1, sm: 2, md: 2 },
                  // Set dynamic height based on screen size
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      textAlign="start"
                      color="#572575"
                      fontFamily="Inter"
                      fontSize="16px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 700 }}
                    >
                      {defaultAddressData?.is_default
                        ? "Default Address"
                        : `Address `}
                    </Typography>
                  </Grid>

                  {/* <Grid
                    item
                    xs={12}
                    sm={6}
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={2}
                  >
                    <Box
                      width={24}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenEditressPopup(userAddress);
                      }}
                    >
                      <Icon
                        icon="fe:edit"
                        color="#572575"
                        width={20}
                        height={18}
                      />
                    </Box>
                    {userAddress?.is_default === true ? (
                      <Tooltip title="Please set a different address as the default before deleting this one">
                        <Box
                          width={24}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (userAddress?.is_default === false) {
                              handleOpendeletePopup(userAddress?.id);
                            }
                          }}
                          sx={{
                            opacity:
                              userAddress?.is_default === true && "25%",
                          }}
                        >
                          <Icon
                            icon="material-symbols:delete-outline-rounded"
                            color="#F31919"
                            width={20}
                            height={18}
                          />
                        </Box>
                      </Tooltip>
                    ) : (
                      <Box
                        width={24}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpendeletePopup(userAddress?.id);
                        }}
                      >
                        <Icon
                          icon="material-symbols:delete-outline-rounded"
                          color="#F31919"
                          width={20}
                          height={18}
                        />
                      </Box>
                    )}
                  </Grid> */}

                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      {/* name */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          color="#555555"
                          fontFamily="Inter"
                          fontSize="14px"
                          lineHeight="100%"
                          letterSpacing="0px"
                          fontStyle="normal"
                          style={{ fontWeight: 400 }}
                        >
                          Name :{" "}
                          <span style={{ color: "#000000" }}>
                            {userAddress?.name}
                          </span>
                        </Typography>
                      </Grid>

                      {/* country */}

                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          color="#555555"
                          fontFamily="Inter"
                          fontSize="14px"
                          lineHeight="100%"
                          letterSpacing="0px"
                          fontStyle="normal"
                          style={{ fontWeight: 400 }}
                        >
                          Country :{" "}
                          <span style={{ color: "#000000" }}>
                            {userAddress?.country?.country_name}
                          </span>
                        </Typography>
                      </Grid>

                      {/* State */}

                      <Grid item xs={12} sm={6} md={6}>
                        <Typography
                          color="#555555"
                          fontFamily="Inter"
                          fontSize="14px"
                          lineHeight="100%"
                          letterSpacing="0px"
                          fontStyle="normal"
                          style={{ fontWeight: 400 }}
                        >
                          State :{" "}
                          <span style={{ color: "#000000" }}>
                            {userAddress?.state?.state_name}
                          </span>
                        </Typography>
                      </Grid>

                      {/* city */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          color="#555555"
                          fontFamily="Inter"
                          fontSize="14px"
                          lineHeight="100%"
                          letterSpacing="0px"
                          fontStyle="normal"
                          style={{ fontWeight: 400 }}
                        >
                          City :{" "}
                          <span style={{ color: "#000000" }}>
                            {userAddress?.city?.city_name}
                          </span>
                        </Typography>
                      </Grid>

                      {/* zip code */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Typography
                          color="#555555"
                          fontFamily="Inter"
                          fontSize="14px"
                          lineHeight="100%"
                          letterSpacing="0px"
                          fontStyle="normal"
                          style={{ fontWeight: 400 }}
                        >
                          Zip Code :{" "}
                          <span style={{ color: "#000000" }}>
                            {userAddress?.zip_code}
                          </span>
                        </Typography>
                      </Grid>

                      {/* address */}
                      <Grid item xs={12} sm={6} md={6}>
                        <Typography
                          color="#555555"
                          fontFamily="Inter"
                          fontSize="14px"
                          lineHeight="1.4"
                          letterSpacing="0px"
                          fontStyle="normal"
                          style={{ fontWeight: 400 }}
                        >
                          Street Address :{" "}
                          <span style={{ color: "#000000" }}>
                            {userAddress?.address}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          )}
        </Grid>
      </GlobalCard>

      <CustomPopup
        handleClose={handleCloseAddAddressPopup}
        component={
          <AddNewAddressForm
            handleClose={handleCloseAddAddressPopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            setSuccessTitle={setMessageTitle}
            setSubMessage={setSubMessage}
          />
        }
        open={OpenAddAddressPopup}
        subtitle=""
        maxWidth="sm"
      />

      <CustomPopup
        handleClose={handleCloseAddressListPopup}
        component={
          <ShowAllAddressList
            handleClose={handleCloseAddressListPopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            setMessageTitle={setMessageTitle}
            setSubMessage={setSubMessage}
            setRefreshPage={setRefreshPage}
          />
        }
        open={openAddressListPopup}
        subtitle=""
        maxWidth="md"
        hideCrossButton={true}
      />

      <SussceeffulyMessageScreen
        text={messageTitle}
        subText={subMessage}
        buttonTitle="Thanks, Got it"
        // startIcon={<DoneIcon />}

        handleClose={handleCloseSuccessPopup}
        open={openSuccesPopup}
        refreshPage={refreshPage}
      />

      <CustomPopup
        handleClose={handleCloseEditAddressPopup}
        component={
          <EditNewAddress
            handleClose={handleCloseEditAddressPopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            setMessageTitle={setMessageTitle}
            setSubMessage={setSubMessage}
            selectedData={selectedData}
            setRefreshPage={setRefreshPage}
            setUserAddress={setUserAddress}
          />
        }
        open={OpenEditAddress}
        subtitle=""
        maxWidth="sm"
      />

      <DeleteConfirmationPopup
        open={openDeleteConfirmation}
        text="Delete Address Permanently ?"
        subtext="Oops! Are you sure you want to remove this address? You won’t be able to get it back."
        buttonTitle="Yes, Remove It"
        handleClose={handleClosedeletePopup}
        handleSubmit={handleCancelAddress}
      />
      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={messageTitle}
        buttonTitle={buttonTitle}
        maxWidth="xs"
      />
    </>
  );
}
